import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ModalShare from '../../atoms/ModalShare';
import ShareIcon from 'ui/components/atoms/Icons/ShareIcon';
import ServiceTags from '../../molecules/ServiceTags';
import useIsNativeView from '../../../hooks/useIsNativeView';
import { triggerNativeMessage } from '../../../helpers/utils';
import ShowMoreContent from '../../atoms/ShowMoreContent';
import { IRootState } from '../../../store';
import { usePathname } from 'next/navigation';
import eventClickCouponService from '../../../helpers/emarsys/coupon-service/eventClickCouponService';
import eventClickPackageService from '../../../helpers/emarsys/package-service/eventClickPackageService';
import eventClickAccessories from '../../../helpers/emarsys/accessories/eventClickAccessories';
import { IBreadcrumbs } from '../Breadcrumbs';

interface ServiceDetailHeaderProps {
  title?: string;
  desc?: string;
  isCMS?: boolean;
  serviceModelTag?: Array<{ text: string; iconUrl: string; hide?: boolean }>;
  dataGTM?: {
    category?: {
      type?: string;
    };
    tag?:
      | {
          name?: string;
        }[]
      | {
          tagName?: string;
        };
    startDate?: string;
    endDate?: string;
    titlePage?: string;

    carName?: string;
    detail?: {
      detailContent?: string;
    };
    contentCategory?: {
      name: string;
    };
    serviceProductTitle?: string;
    detailContent?: string;
  };
  serviceType?: string;
  containerClassname?: string;
  serviceDiscounts?: any[];
  feature?: string;
  impressionData?: {
    pageTitle: string;
    breadCrumb: IBreadcrumbs[];
    sku?: string;
    skuPrice?: string;
    carModel?: string[];
  };
}

const ServiceDetailHeader = ({
  title,
  desc,
  isCMS = false,
  serviceModelTag,
  dataGTM,
  serviceType,
  containerClassname = '',
  serviceDiscounts,
  feature,
  impressionData,
}: ServiceDetailHeaderProps) => {
  const [showModalShare, setShowModalShare] = useState(false);

  const dispatch = useDispatch();
  const { screenSize } = useSelector((state: IRootState) => state.page) || {};
  const { selectedCar, selectedPackage } =
    useSelector((state: IRootState) => state.servicePackage) || {};
  const { userData } = useSelector((state: IRootState) => state.auth) || {};

  const isNativeView = useIsNativeView();
  const pathname = usePathname();

  const handleClickShare = (message, titlePage) => {
    triggerNativeMessage(message, { titlePage });

    if (isNativeView) {
      setShowModalShare(false);
    } else if (screenSize.mobile) {
      handleShare();
    } else {
      setShowModalShare(true);
    }
  };

  // Trigger share system on mobile
  const handleShare = async () => {
    if (screenSize.mobile && navigator.share) {
      try {
        await navigator.share({
          title: serviceType === 'coupon' ? 'Kupon Servis' : 'Paket Servis',
          text: 'Check out this sevice package!',
          url: typeof window !== 'undefined' ? window.location.href : '',
        });
      } catch (error) {
        console.error('Share error:', error);
        // open modal if failed open navigator.share() except cancelation
        if (!error.toString().includes('AbortError')) {
          setShowModalShare(true);
        }
      }
    } else {
      setShowModalShare(true);
    }
  };

  const actionClickEmarsys = (buttonName: string) => {
    if (feature === 'COUPON_SERVICE') {
      eventClickCouponService(
        dispatch,
        selectedPackage,
        selectedCar,
        impressionData.pageTitle,
        impressionData.breadCrumb,
        userData?.phoneNumber ? userData?.phoneNumber?.replace('+62 ', '0') : '',
        'bagikan',
        buttonName
      );
    } else if (feature === 'PACKAGE_SERVICE') {
      eventClickPackageService(
        dispatch,
        selectedPackage,
        selectedCar,
        impressionData.pageTitle,
        impressionData.breadCrumb,
        userData?.phoneNumber ? userData?.phoneNumber?.replace('+62 ', '0') : '',
        'bagikan',
        buttonName
      );
    } else if (feature === 'ACCESSORIES') {
      eventClickAccessories(
        dispatch,
        impressionData.sku,
        impressionData.skuPrice,
        impressionData.pageTitle,
        impressionData.breadCrumb,
        userData?.phoneNumber ? userData?.phoneNumber?.replace('+62 ', '0') : '',
        'bagikan',
        buttonName,
        impressionData.carModel
      );
    }
  };

  return (
    <>
      <div className={`${containerClassname}`}>
        <ServiceTags items={serviceModelTag} className="mb-1 lg:mb-4 lg:flex hidden" width={300} />

        <div
          className={`px-4 ${serviceDiscounts && serviceDiscounts?.length > 0 ? '' : 'pb-4'} lg:px-0`}
        >
          <div className="flex justify-between items-center mt-1 mb-2 lg:mt-0">
            <h1 className="nama-kupon-service-toyota text-base font-bold text-reliableBlack lg:text-2xl">
              {title}
            </h1>
            <button
              id={'modal-share'}
              type="button"
              aria-label="Share Button"
              className="w-10 h-10 bg-reliableBlack5 flex justify-center items-center rounded lg:bg-[#E9E9E9]"
              onClick={isCMS ? () => {} : () => handleClickShare('goToShare', title)}
            >
              <ShareIcon />
            </button>
          </div>

          <ShowMoreContent desc={desc} showLessTextLine={2} />
        </div>
      </div>

      {/* Social media share modal */}
      {showModalShare && (
        <ModalShare
          copyLink={dataGTM}
          visible={showModalShare}
          link={`${URL}${pathname}`}
          onClose={() => setShowModalShare(false)}
          actionClick={actionClickEmarsys}
        />
      )}
    </>
  );
};
export default ServiceDetailHeader;
